import * as React from "react"
import type { SVGProps } from "react"
const SvgParagraph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 20.14a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72v-5a4.8 4.8 0 0 1-3.54-1.46Q5 11.22 5 9.14c0-2.08.49-2.56 1.46-3.53A4.8 4.8 0 0 1 10 4.14h8q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28h-1v13q0 .43-.29.72a1 1 0 0 1-.71.28 1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72v-13h-3v13q0 .43-.29.72a1 1 0 0 1-.71.28" />
  </svg>
)
export default SvgParagraph
